import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="search"
export default class extends Controller {
  static values = { delay: Number }
  connect() {
    this.timeout = null
  }

  submitForm() {
    this.timeout = setTimeout(() => {
      this.element.requestSubmit()
    }, this.delayValue || 0)
  }
}
